import { Container } from '@cgs/wge';
import { SpinResponse } from '@cgs/data-access';
import {
  AbstractListener,
  GameStateMachineNotifierComponent,
} from '../../../game/components/game_state_machine_notifier_component';
import { ResourcesComponent } from '../../../game/components/resources_component';
import {
  T_GameStateMachineNotifierComponent,
  RESOURCES_COMPONENT_TOKEN,
} from '../../../type_definitions';
import { GameStateMachineStates } from '../../../reels_engine/state_machine/game-state-machine-states';
import { GameStateMachine } from '../../../reels_engine/state_machine/game-state-machine';

export interface BackgroundComponentParams {
  sceneId: string;
  defaultState: string;
  freeSpinsState: string;
  defaultToFreeSpinsState: string | null;
  freeSpinsToDefaultState: string | null;
}

const defaultParams: BackgroundComponentParams = {
  sceneId: 'BG_Modes',
  defaultState: 'bg_default',
  freeSpinsState: 'bg_fs',
  defaultToFreeSpinsState: 'bg_default_to_fs',
  freeSpinsToDefaultState: 'bg_fs_to_default',
};

export const BACKGROUND_MODE_COMPONENT_TOKEN = Symbol('BACKGROUND_MODE_COMPONENT_TOKEN');

export class BackgroundModeComponent implements AbstractListener {
  private resourceComponent: ResourcesComponent;
  private gameStateMachine: GameStateMachine<SpinResponse>;
  private params: BackgroundComponentParams;

  constructor(container: Container, params: Partial<BackgroundComponentParams> = {}) {
    this.params = { ...defaultParams, ...params };

    this.resourceComponent = container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN);

    const notifierComponent = container.resolve<GameStateMachineNotifierComponent>(
      T_GameStateMachineNotifierComponent
    );
    notifierComponent.notifier.addListener(this);

    this.gameStateMachine = notifierComponent.gameStateMachine;
  }

  public onStateEntered(slotState: string): void {
    switch (slotState) {
      case GameStateMachineStates.FreeSpinRecovery:
        this.setState(this.params.freeSpinsState);
        break;
    }
  }

  public onStateExited(slotState: string): void {
    switch (slotState) {
      case GameStateMachineStates.BeginFreeSpinsPopup:
        this.setState(this.params.defaultToFreeSpinsState || this.params.freeSpinsState);
        break;
      case GameStateMachineStates.EndOfFreeSpinsPopup:
        this.setState(this.params.freeSpinsToDefaultState || this.params.defaultState);
        break;
    }
  }

  public updateCurrentState(animate: boolean = false): void {
    let state: string;

    if (animate) {
      state = this.gameStateMachine.curResponse?.freeSpinsInfo
        ? this.params.defaultToFreeSpinsState || this.params.freeSpinsState
        : this.params.freeSpinsToDefaultState || this.params.defaultState;
    } else {
      state = this.gameStateMachine.curResponse?.freeSpinsInfo
        ? this.params.freeSpinsState
        : this.params.defaultState;
    }

    this.setState(state);
  }

  private setState(state: string): void {
    const backgroundModesScene = this.resourceComponent.bg.findById(
      this.params?.sceneId || defaultParams.sceneId!
    );

    backgroundModesScene?.stateMachine?.switchToState(state);
  }
}
